import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CustomContentSection } from '@/components/custom-content-section';
import { PrimaryLayout } from '@/layouts/primary';
import { Text } from '@mantine/core';
import { IconMailOpened } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';

export const PasswordLinkSentPage = () => {
	const navigate = useNavigate();
	const backToLogin = useCallback(() => navigate({ to: '/auth/login' }), [navigate]);
	const backToLoginButton = useMemo(
		() => <StandardButton onClick={backToLogin}>Back to Login</StandardButton>,
		[backToLogin]
	);

	return (
		<PrimaryLayout footer={{ children: backToLoginButton }}>
			<CustomContentSection
				location={ContentSectionLocation.PasswordLinkSent}
				placement={ContentSectionPlacement.Top}
			/>
			<ContentPanel gap="md" justify="center" align="center" flex={1}>
				<IconMailOpened size={32} />
				<Text ta="center" size="lg" fw={900}>
					Password Link Sent
				</Text>

				<Text ta="center" size="sm" fw={400}>
					If your email matched one that is already in the system, then you have received a password
					reset link.
				</Text>
				<Text ta="center" size="sm" fw={400}>
					Check your email inbox and spam for a link to reset your password.
				</Text>
			</ContentPanel>
			<CustomContentSection
				location={ContentSectionLocation.PasswordLinkSent}
				placement={ContentSectionPlacement.Middle}
			/>
			<CustomContentSection
				location={ContentSectionLocation.PasswordLinkSent}
				placement={ContentSectionPlacement.Bottom}
			/>
		</PrimaryLayout>
	);
};
